var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291.8,
    height: 150,
    viewBox: "0 0 77.2 72.7",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-269 -103.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-141.3 -137.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-194.3 -136.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-172.8 -136.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-196.8 -94.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-163.3 -129.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-181.5 -136.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-160.6 -128.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-110.7 -109.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-130.8 -83)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-244.8 -160.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-258.1 -148.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-225.2 -152.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-238.1 -138.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.8h841.9V0H0Z",
    transform: "translate(-176.6 -185.3)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-29.2-26.2 5.6-1.8 29 28Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 71.2 59)",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 35.2 10.6 2.2-2.3-13-4L1.5-3Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 26.2 47)",
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s3.9 4.4 12 3.3c8.2-1 10.7-7 10.7-7l-6-32.2s-2-4.5-9-6.1c-7-1.6-11.3 4.6-11.3 4.6z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 44.8 47.4)",
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 86.6-44.6 2.8 2.3L-6 6.8l-4.7-1Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 37.3 47.4)",
    clipPath: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-2.6-2.5-4.7-5.6-4.7-3.2 0-5.7 2-5.7 4.7 0 2.6 2.5 4.7 5.7 4.7 3 0 5.6-2 5.6-4.7",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 45.7 62.3)",
    clipPath: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 17.4-21.3 17.1 8.5L18.2 7.4C18.3 7.2 11 4.2 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 34 50)",
    clipPath: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 40.3 47.4)",
    clipPath: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-19.8-7.6 17.6-23.8 19.8 9.9z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 33 50.4)",
    clipPath: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-35.6-13.4 19.3-31 33.9 17z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 15.4 57)",
    clipPath: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 25.1 12.5L7.4 36.6l-24.8-9.4Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 22.4 66.3)",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7-2.7 10.8-14 7.8 4z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 62.7 39)",
    clipPath: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.5 3.3-11 12-7-2.7Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 67.4 43.2)",
    clipPath: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.2-4 12-15.9 9.5 4.8Z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 55.7 41.7)",
    clipPath: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.8 4.4L-2 18.5l-9.2-3.5z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 60.3 46.7)",
    clipPath: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c39.5 0 76.7-9.6 109.4-26.6V85.7h-218.8V-26.6C-76.7-9.6-39.4 0 0 0",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 38.6 30.2)",
    clipPath: "url(#o)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlink);
export default __webpack_public_path__ + "static/media/logo-blink.f01df0731e3689363250196f7f6e12ee.svg";
export { ForwardRef as ReactComponent };